import {
  ORDER_STATUS_ORDERED,
  ORDER_STATUS_DEALER_PROCESSING,
  ORDER_STATUS_DEALER_ACCEPTED,
  ORDER_STATUS_DEALER_CANCELLED,
  ORDER_STATUS_DEALER_DECLINED,
  ORDER_STATUS_DEALER_DELIVERED,
  ORDER_STATUS_CONSUMER_CANCELLED,
} from '@chama/utils/constants/status';
import orderedIcon from '@chama/statics/assets/svg/order-status-icon-ordered.svg';
import processingIcon from '@chama/statics/assets/svg/order-status-icon-dealer-processing.svg';
import acceptedIcon from '@chama/statics/assets/svg/order-status-icon-dealer-accepted.svg';
import deliveredIcon from '@chama/statics/assets/svg/order-status-icon-dealer-delivered.svg';
import consumerCancelledIcon from '@chama/statics/assets/svg/order-status-icon-consumer-canceled.svg';
import csCancelledIcon from '@chama/statics/assets/svg/order-status-icon-cs-cancelled.svg';
import dealerCancelledIcon from '@chama/statics/assets/svg/dealer-cancelled-icon.svg';

const getOrderStatusIcon = (status, isCsUser) => {
  if (status === ORDER_STATUS_ORDERED) {
    return orderedIcon;
  }

  if (status === ORDER_STATUS_DEALER_PROCESSING) {
    return processingIcon;
  }

  if (status === ORDER_STATUS_DEALER_ACCEPTED) {
    return acceptedIcon;
  }

  if (status === ORDER_STATUS_DEALER_CANCELLED || status === ORDER_STATUS_DEALER_DECLINED) {
    if (isCsUser) {
      return csCancelledIcon;
    }

    return dealerCancelledIcon;
  }

  if (status === ORDER_STATUS_DEALER_DELIVERED) {
    return deliveredIcon;
  }

  if (status === ORDER_STATUS_CONSUMER_CANCELLED) {
    return consumerCancelledIcon;
  }

  return '';
};

export default getOrderStatusIcon;



// WEBPACK FOOTER //
// ./src/modules/orders/components/OrderDetailsLayout/EventHistory/get-order-status-icon.js